import {
  ScheduleV3Group,
  ScheduleV3GroupedData,
  ScheduleV3FilterState,
  ScheduleV3UIState,
  ScheduleV3Conflict,
  SchedulesV3GroupByType,
} from '../model/scheduleV3';
import { ScheduleSidebarItem } from '../response/scheduleV3';

export interface ScheduleV3SidebarLayoutState {
  items: ScheduleSidebarItem[];
  groupBy: 'employee' | 'department' | 'site' | 'tags' | null;
  isLoading: boolean;
  error: string | null;
  status: boolean | null;
  message: string | null;
  lastFetchedRange: {
    startDate: string;
    endDate: string;
  } | null;
}

export interface ScheduleV3State {
  // Data
  groups: ScheduleV3Group[];
  groupedData: ScheduleV3GroupedData;
  sidebarLayout: ScheduleV3SidebarLayoutState;
  
  // Loading states
  isLoading: boolean;
  isRefreshing: boolean;
  
  // Error handling
  error: string | null;
  lastFetchError: string | null;
  
  // Filters
  filters: ScheduleV3FilterState;
  
  // UI State
  ui: ScheduleV3UIState;
  
  // Conflicts
  conflicts: ScheduleV3Conflict[];
  
  // Metadata
  lastFetchTime: number | null;
  currentDateRange: {
    startDate: string;
    endDate: string;
  } | null;
  currentGroupBy: SchedulesV3GroupByType;
  
  // Statistics
  statistics: {
    totalSchedules: number;
    totalEmployees: number;
    totalHours: number;
    totalGroups: number;
  };
}

// Initial state
export const initialScheduleV3State: ScheduleV3State = {
  groups: [],
  groupedData: {},
  sidebarLayout: {
    items: [],
    groupBy: null,
    isLoading: false,
    error: null,
    status: null,
    message: null,
    lastFetchedRange: null,
  },
  isLoading: false,
  isRefreshing: false,
  error: null,
  lastFetchError: null,
  filters: {
    groupBy: 'department',
    departmentCodes: [],
    siteIds: [],
    employeeIds: [],
    showSchedules: true,
    showTimeoff: true,
    showHolidays: true,
    showUnavailability: false,
    showOpenShifts: false,
  },
  ui: {
    expandedGroups: [],
    viewMode: 'grid',
  },
  conflicts: [],
  lastFetchTime: null,
  currentDateRange: null,
  currentGroupBy: 'department',
  statistics: {
    totalSchedules: 0,
    totalEmployees: 0,
    totalHours: 0,
    totalGroups: 0,
  },
};
